import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  props: {
    date: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  }
});